// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LId4","toggleWrap":"styles_toggleWrap__2nx-z","content":"styles_content__1zKrT","selectAreaCode":"styles_selectAreaCode__3nekm"};